import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useDispatch } from 'react-redux';

import {
  handleUserRegistration,
  RegistrationValues,
  Register,
  handleLoggingIn,
} from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { ENVIRONMENT_URL } from '@backrs_ui/grow-ui/src/settings';
import { handleAfterLogin } from '@backrs_ui/grow-ui/src/utils/loginHelper';
import { getGuestTokenIfPresent } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

export const RegistrationPage = () => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const afterRegistration = async (registrationResult: { email: string; password: string }) => {
    try {
      // After successful registration, automatically log the user in using the same handler as LoginPageContainer
      await handleLoggingIn({
        phone: '',
        email: registrationResult.email,
        password: registrationResult.password,
        environmentUrl: ENVIRONMENT_URL,
        afterLogin: (loginResponse) =>
          handleAfterLogin({
            access_token: loginResponse.access_token,
            dispatch,
            navigate,
            setErrorMessage,
          }),
        setErrorMessage,
      });
    } catch (error) {
      console.error('Error during automatic login:', error);
      // If auto-login fails, still redirect to login page
      navigate(APP_ROUTE.LOGIN);
    }
  };

  const handleRegistration = async (payload: RegistrationValues) => {
    await handleUserRegistration({
      payload,
      afterRegistration: () =>
        afterRegistration({
          email: payload.email,
          password: payload.password,
        }),
      environmentUrl: ENVIRONMENT_URL,
      setErrorMessage,
      guestToken: getGuestTokenIfPresent() ?? undefined,
    });
  };

  return <Register handleRegistration={handleRegistration} errorMessage={errorMessage} />;
};
